import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  get_expiring_products,
  updateProduct,
  updateProductQty,
} from "../../../Utility/Api";
import { NaviGate, getStoredEntriesPerPage } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { Pagination } from "../../Common/Functions";
const Product_expire = () => {

  const { selectedWarehouse, showLoader, hideLoader, UserItem, shopItem } =
    useContext(WarehouseContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));
  const [expiredProducts, setExpiredProducts] = useState([]);
  const [Expired, setExpired] = useState(1); // 0 = Expired, 1 = Expiring Soon
  const [SearchQurey, setSearchQurey] = useState('');
  const [daysFilter, setDaysFilter] = useState(10); // default 10 days

  useEffect(() => {
    if (shopItem?.id) {
      fetchExpiredProducts(currentPage, SearchQurey, daysFilter, entriesPerPage);
    }
  }, [shopItem, Expired, SearchQurey, daysFilter, entriesPerPage, currentPage, selectedWarehouse]);

  const fetchExpiredProducts = async (
    page = currentPage,
    search = SearchQurey,
    days = daysFilter,
    limit = entriesPerPage
  ) => {
    if (!shopItem || !shopItem.id) return;

    showLoader();
    try {
      const response = await get_expiring_products(
        page,
        shopItem.id,
        search,
        days,
        limit,
        Expired === 0 ? "expired" : "expiring"
      );

      console.log("API Response:", response.data);

      if (response.data) {
        setExpiredProducts(response.data.data || []);
        const calcPages = response.data.pagination?.total_pages || Math.max(1, Math.ceil((response.data.pagination?.total_records || response.data.data?.length || 0) / limit));
        setTotalPages(calcPages);
      }
    } catch (error) {
      console.error("Error fetching expired products:", error);
      toast.error("Failed to load expiry data");
      setExpiredProducts([]);
      setTotalPages(0);
    } finally {
      hideLoader();
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  // const calculateExpiryStatus = (expiryDate) => {
  //   if (!expiryDate) return "Unknown";

  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   const expDate = new Date(expiryDate);
  //   expDate.setHours(0, 0, 0, 0);

  //   if (expDate < today) {
  //     return "Expired";
  //   }

  //   const differenceInTime = expDate.getTime() - today.getTime();
  //   const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

  //   if (differenceInDays <= 10) {
  //     return `Expires in ${differenceInDays} days`;
  //   }

  //   return "Valid";
  // };

  const calculateExpiryStatus = (expiry_date) => {
    if (!expiry_date) return "Unknown";

    const today = new Date(); // current date
    const expiryDate = new Date(expiry_date);
    const diffTime = expiryDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // days left

    if (diffDays <= 0) return "Expired";
    return `${diffDays} day(s) left`;
  };


  return (
    <>
      <div className="">
        {/* <div className="page-wrappers"> */}
        <div className="page-content">
          {/* <div className="page-content"> */}
          <div className="">
            <NaviGate />
          </div>

          <h6 className="text-uppercase ms-3">Product Expiry</h6>

          <hr className="mt-1" />
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between flex-wrap">
                {/* Search */}
                <div className="col-12 col-md-4 col-lg-3 mb-3">
                  <div className="d-flex position-relative" style={{ width: "100%" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      onChange={(e) => setSearchQurey(e.target.value)}
                      value={SearchQurey}
                    />
                    <img
                      src="/assets/images/icons/search.png"
                      alt="Search Icon"
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "18px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                {/* Days Filter and Tabs */}
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <select
                    className="form-select form-select-sm"
                    value={daysFilter}
                    onChange={(e) => setDaysFilter(e.target.value)}
                  >
                    <option value="">Today</option>
                    <option value="5">5 Days</option>
                    <option value="10">10 Days</option>
                    <option value="30">30 Days</option>
                  </select>

                  {/* Tabs */}
                  {/* <div className="tab-container">
                    <button
                      className={`tab-button ${Expired === 0 ? "active-tab" : ""}`}
                      onClick={() => setExpired(0)}
                    >
                      Expired
                    </button>
                    <button
                      style={{ width: "max-content" }}
                      className={`tab-button ${Expired === 1 ? "active-tab" : ""}`}
                      onClick={() => setExpired(1)}
                    >
                      Expires Soon
                    </button>
                  </div> */}
                </div>
              </div>

              <div className="table-responsive">
                <table
                  id="example"
                  className="table table-sm table-bordered align-baseline"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Raw Material</th>
                      <th>Quantity</th>
                      <th>Remaining Quantity</th>
                      <th>Expiry Date</th>
                      <th>Expiry Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expiredProducts && expiredProducts.length > 0 ? (
                      expiredProducts.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                          <td>{formatDate(item.date_time)}</td>
                          <td>{item.product_name}</td>
                          <td>{item.qty} {item.units}</td>
                          <td>{Number(item.remaining).toFixed(2)} {item.units}</td>
                          <td>{item.expiry_date}</td>
                          <td>
                            {(() => {
                              const status = calculateExpiryStatus(item.expiry_date);
                              const isExpired = status === "Expired";
                              return (
                                <span className={`badge ${isExpired ? "bg-danger" : "bg-warning"}`}>
                                  {status}
                                </span>
                              );
                            })()}
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-3">
                          No {Expired === 0 ? "expired" : "expiring"} raw materials found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                entriesPerPage={entriesPerPage}
                onEntriesPerPageChange={(val) => {
                  setEntriesPerPage(val);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product_expire
